// removed by extract-text-webpack-plugin
module.exports = {"textarea":"_21Whs2GaUzkMv9N0UgcyRN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleLine/SingleLine.scss
// module id = 1091
// module chunks = 0